import { PureComponent } from "react";
import { Grid } from "semantic-ui-react";
import './Layout.css'

class Layout extends PureComponent {
    render() {
        const { left, right } = this.props;
        return <Grid padded className="Layout">
            <Grid.Row columns={2}>
                <Grid.Column width={4}>
                    {left}
                </Grid.Column>
                <Grid.Column width={12}>
                    {right}
                </Grid.Column>
            </Grid.Row>
        </Grid>
    }
}

export default Layout;